import { Backdrop, CircularProgress, Container, Divider, Grid } from '@material-ui/core';
import { ArrowBack, Save as SaveIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup'
import Success from '../../components/Form/Success';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import permissions from '../../utils/Permissions';
import TextField from '../../components/Form/TextField';
import MvmApi from '../../services/MvmApi';
import { useStyles } from './Style';
import ConfirmModalUI from '../../components/ui/ConfirmModalUI';

interface IFormInput {
    mvmNumberCabin: any;
    mvmNumberCart: any;
}

const opcoes = [
    { url: '/MvmComposition', descricao: 'Vincular MVMs', state: {}},
    { url: 'printMvm', descricao: 'Imprimir Mvm', state: {}},
    { url: '/mvm', descricao: 'Pesquisar Mvm', state: {}},
]

const opcoesEmpty = [
    { url: '/MvmComposition', descricao: 'Vincular MVMs', state: {}},
]

const opcoesCart = [
    { url: 'printMvm', descricao: 'Imprimir Mvm (Carreta)', state: {}},
]

const MvmCompositionForm: React.FC = () => {
    
    const classes = useStyles();
    const { user, hasPermission } = useAuth()
    const history = useHistory()
    const { t } = useTranslation("Mvm")
    const { t: tGeneral } = useTranslation("General")
    const { t: tValidation } = useTranslation("Validation")
    const { enqueueSnackbar } = useSnackbar()
    const [circularLoading, setCircularLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [mvmComposition, setMvmComposition] = useState<any>(null)
    const [mvmNumber, setMvmNumber] = useState<string>('')
    const [mvmNumberCart, setMvmNumberCart] = useState<string>('')
    const [confirmAction, setConfirmAction] = useState<boolean>(false)
    const { control, handleSubmit, getValues, setError, clearErrors } = useForm<IFormInput>(
    {
        defaultValues: { mvmNumberCabin: '', mvmNumberCart: '' }
    })

    useEffect(() => {
        if (!hasPermission(permissions.MVM.Edit))
            history.replace('NoPermission');
    }, [history, user])

    async function add() {

        var data = getValues()
        var validForm = await formValidation(data)

        if (validForm == false) {
            return;
        }

        setCircularLoading(true)

        await MvmApi.CreateMvmCompositionExit(data.mvmNumberCabin, data.mvmNumberCart)
            .then((response: any) => {
                enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' })
                setMvmComposition(response)
                setSuccess(true);
                setCircularLoading(false)
                setMvmNumber(data.mvmNumberCabin)
                setMvmNumberCart(data.mvmNumberCart)
            })
            .catch(()=> {
                enqueueSnackbar(tGeneral('returnSubmitEditFormError'), { variant: 'error'});
                setCircularLoading(false)
            })
    }

    const formValidation = async (data : any) => {
        var result = false

        clearErrors()
        try {   

            const schema = Yup.object().shape({
                mvmNumberCabin: Yup.string().required(tValidation("requiredField"))
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true
        }
        catch (err) {

            var errors: string[] = []

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length == 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as 
                        "mvmNumberCabin", 
                    { message: error.message });
                })

                errors.forEach(element => { 
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' }) 
                    else    
                        enqueueSnackbar(element, { variant: 'warning' }) 
                })
            }

            result = false;
        }
        return result
    }

    const preSubmit = async () =>  {
        var data = getValues()
        var validForm = await formValidation(data)

        if (confirmAction || validForm == false) {
            return;
        }

        setConfirmAction(true)
    }

    const onSubmit = (data: any) => { }

    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        {mvmComposition ?
                                <>
                                    <Success opcoes={opcoes} mvmNumber={mvmNumber} MvmId={mvmComposition.cabinMvmId}/>
                                    <Success opcoes={opcoesCart} mvmNumber={mvmNumberCart} MvmId={mvmComposition.cartMvmId}/>
                                </>
                            :
                                <Success opcoes={opcoesEmpty} mvmNumber={mvmNumber} />
                        }
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">
            <ConfirmModalUI
                isOpen={confirmAction}
                mensage={t('mvmCompositionConfirmMessage')}
                onClose={() => setConfirmAction(false)}
                onCloseConfirmModal={() => add()}
            /> 
            <PageTitle title={t("vinculateMvm")} />
            <div className={classes.rootContent}>
                <form onSubmit={handleSubmit(onSubmit)} >      
                    <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>              
                    <Divider style={{ marginTop: '10px' }} />
                    <Grid container spacing={1}>
                        <Grid item xs={1}>
                            <TextField
                                label={t('mvmNumber') + ': ' + t('cabin')} 
                                name='mvmNumberCabin'
                                control={control}
                                autoFocus={true}
                                style={{width: "100%", marginRight: 10}} />
                        </Grid>
                        <Grid item xs={1}>
                            <TextField
                                label={t('mvmNumber') + ': ' + t('cart')} 
                                name='mvmNumberCart'
                                control={control}
                                style={{width: "100%", marginRight: 10}} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <ButtonUI
                            style={{ marginTop: 15, marginLeft: 15 }}
                            variant="outlined"
                            color="secondary"
                            onClick={() => history.replace('/Mvm')}
                            startIcon={<ArrowBack />}>
                            {tGeneral("back")}
                        </ButtonUI>
                        <ButtonUI
                            style={{ marginTop: 15, marginLeft: 15 }}
                            variant="outlined"
                            color="primary"
                            onClick={() => preSubmit() }
                            startIcon={<SaveIcon />}>
                            {tGeneral("save")}
                        </ButtonUI>
                    </Grid>
                </form>
            </div>
        </Container>
    )
}
export default MvmCompositionForm
